// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer-socialmedia":"Footer_footer-socialmedia__TgNTD"};